import { c as _c } from "react/compiler-runtime";
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import CourseSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-course-item/components/course-select';
import ModuleSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-module-item/components/module-select';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerModuleEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerModuleItemProps extends EditTriggerItemInterface<TriggerModuleEditInterface> {}
const TriggerModuleItem = t0 => {
  const $ = _c(17);
  const {
    trigger,
    triggers,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.course || $[9] !== trigger.id || $[10] !== trigger.module || $[11] !== triggers) {
    t2 = t3 => {
      const {
        data,
        renderTriggerLabel,
        onOpen,
        onClear
      } = t3;
      return <><CourseSelect isStatic={isStatic} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  course: {
                    id: data_0
                  },
                  module: {
                    id: undefined
                  }
                };
              } else {
                return el;
              }
            })
          }));
          onClear(AutomationRuleTriggersDataEnum.module);
        }} triggerId={trigger.id} courseId={trigger.course.id} course={trigger.course} courseData={data.courseData} errors={errors} renderTriggerLabel={renderTriggerLabel} onOpen={onOpen} hint={t("dashboard.automation_rule.trigger.module.course_hint")} />{trigger.course.id && <ModuleSelect isStatic={isStatic} hint={t("dashboard.automation_rule.trigger.module.module_hint")} triggerId={trigger.id} onOpen={onOpen} module={trigger.module} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                module: {
                  id: data_1
                }
              };
            } else {
              return el_0;
            }
          })
        }))} errors={errors} moduleId={trigger.module?.id} moduleData={data.moduleData} />}</>;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.course;
    $[9] = trigger.id;
    $[10] = trigger.module;
    $[11] = triggers;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[13] = t1;
    $[14] = t2;
    $[15] = trigger;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
export default TriggerModuleItem;